import { useCallback, useMemo, useState } from 'react';
import { LOANER_CAR_USE } from '@/consts/bodyAndPaint';
import { LoanerCarEntryItemType } from '@/types/bodyAndPaint';

interface LoanerCarStateHookProps {
  initial: LoanerCarEntryItemType;
}
export const useLoanerCarState = ({ initial }: LoanerCarStateHookProps) => {
  const [loanerCar, setLoanerCar] = useState(
    initial ?? ({} as LoanerCarEntryItemType),
  );

  const loanerCarSetState = useMemo(() => {
    return {
      loanerCarSelect: (select: number) => {
        setLoanerCar((prev) => ({ ...prev, loanerCarSelect: select }));
      },
      carRequestText: (text: string) => {
        setLoanerCar((prev) => ({ ...prev, carRequestText: text }));
      },
    };
  }, []);

  const loanerCarSelectList = useMemo(() => {
    return {
      loanerCarSelect: Object.values(LOANER_CAR_USE).map((item) => item.label),
    };
  }, []);
  const loanerCarErrorPattern = useMemo(() => {
    return {
      carRequestText: '',
    };
  }, []);

  const [approve, setApprove] = useState(false);
  const handleChangeApprove = useCallback(
    () => setApprove((prev) => !prev),
    [],
  );

  const disabled = useMemo(() => {
    const loanerCarCheck = !!(loanerCar?.loanerCarSelect >= 0);
    const carRequestCheck = !!(
      loanerCar?.carRequestText !== undefined &&
      loanerCar?.carRequestText !== ''
    );
    return !(
      approve &&
      loanerCarCheck &&
      !!(loanerCar?.loanerCarSelect === LOANER_CAR_USE.YES_USE.value
        ? carRequestCheck
        : true)
    );
  }, [approve, loanerCar]);

  return {
    loanerCarInfoState: {
      state: loanerCar,
      setState: loanerCarSetState,
      list: loanerCarSelectList,
      error: loanerCarErrorPattern,
    },
    approveCheck: approve,
    onChangeCheck: handleChangeApprove,
    disabled: disabled,
  };
};
